import { RemittanceType as GqlRemittanceType } from '@willow/graphql-iso/src/app';
import { assertNever, RemittanceType } from '@willow/types-iso';

export function formatRemittanceType(remittanceType: RemittanceType | GqlRemittanceType | null | undefined) {
  switch (remittanceType) {
    case RemittanceType.enum.SCHEDULED_SCHEDULED:
    case GqlRemittanceType.ScheduledScheduled:
      return 'Scheduled/Scheduled';
    case RemittanceType.enum.SCHEDULED_ACTUAL:
    case GqlRemittanceType.ScheduledActual:
      return 'Scheduled/Actual';
    case RemittanceType.enum.ACTUAL_ACTUAL:
    case GqlRemittanceType.ActualActual:
      return 'Actual/Actual';
    case null:
    case undefined:
      return '';
    default:
      assertNever(remittanceType);
  }
}
